export default __webpack_public_path__ + "static/card-example2-bc28ed795ca5b95925bac69aa4521609.png";